<template>
    <span class="mini-badge" :class="badgeClass" v-on="$listeners">
        <slot />
    </span>
</template>

<script>
export default {
    name: "MiniBadge",
    props: {
        type: {
            type: String,
            default: 'rpe'
        },
        level: {
            type: String,
            default: ''
        }
    },
    computed: {
        badgeClass(vm = this) {
            return vm.level ? `mini-badge--${vm.type}-${vm.level}` : ''
        }
    }
}
</script>

<style scoped>
.mini-badge {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
    flex-shrink: 0;
}

.mini-badge--rpe-low {
    background: var(--v-success-base);
    color: #FFFFFF;
}

.mini-badge--rpe-mid {
    background: #F5C842;
    color: #3A2E00;
}

.mini-badge--rpe-high {
    background: var(--v-error-base);
    color: #FFFFFF;
}

.mini-badge--wellness-good {
    background: rgba(34, 197, 94, 0.22);
    color: #4ADE80;
}

.mini-badge--wellness-neutral {
    background: rgba(148, 163, 184, 0.28);
    color: #94A3B8;
}

.mini-badge--wellness-bad {
    background: rgba(239, 68, 68, 0.3);
    color: #F87171;
}

.theme--light .mini-badge--wellness-good {
    color: #1F9D51;
}

.theme--light .mini-badge--wellness-neutral {
    color: #64748B;
}

.theme--light .mini-badge--wellness-bad {
    color: #D13C3C;
}
</style>
